<template>
  <div id="app" class="Site">
    <nav-bar-component class="no-print" @logout="handleLogout"></nav-bar-component>
    <div class="no-print" style="margin-top:20px"></div>
    <!-- BreadCrumbs currentBreadcrumb -->
    <div class="no-print container">
      <nav class="breadcrumb" aria-label="breadcrumbs">
        <ul>
          <li v-for="breadcrumb in currentBreadcrumb" :key="breadcrumb.name" >
            <router-link class="has-text-primary" v-if="breadcrumb.link" v-bind:to="breadcrumb.link">{{breadcrumb.name}}</router-link> 
            
            <router-link to="" v-else class="is-active" aria-current="page">{{breadcrumb.name}}</router-link>
          </li>
        </ul>
      </nav>
    </div>
    
    <div class="no-print" style="margin-top:20px"></div>
   
   <div class="tile is-ancestor">
      <div class="tile is-vertical is-parent">
        <div class="tile is-child">
          <div class="container"> 
              <router-view/>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="columns">
      <div class="column">
        <router-view/>
      </div>
    </div> -->

    <div class="no-print" style="margin-top:50px"></div>

    <footer-Component class="no-print" ></footer-Component>
  </div>
</template>

<script>
import NavBarComponent from './components/general/NavBarComponent'
import FooterComponent from './components/general/FooterComponent'
import SideBarComponent from './components/general/SideBarComponent'
import axios from 'axios'
import { mapGetters } from 'vuex'
import isAfter from 'date-fns/is_after'
import subtractMinutes from 'date-fns/sub_minutes'

export default {  
  name: 'app',
  components: {
    NavBarComponent,
    FooterComponent,
    SideBarComponent
  }, 
  data: function() {
    const data = []
    return {
      data,
      breadcrumbs:[]
    }
  },
  computed: {
    ...mapGetters([
      'base_url', 'currentBreadcrumb', 'token_expiry'
    ]),
  },
  methods: {
    checkSession() {
      if(this.token_expiry) {
        let tenMinutesBeforeExpiry = subtractMinutes(this.token_expiry, 10);
        const now = new Date();

        if(isAfter(now, tenMinutesBeforeExpiry)) { 
          //If the token has expired or will expire in the next 10 minutes
          this.$store.dispatch('logout');
          return this.$router.push({ name: "Login" });
        }
      }
    },
    handleLogout(){
      axios.post(`${this.base_url}accounts/logout/`)
        .then(() => {
          window.localStorage.removeItem('valchrom-token');
          window.localStorage.removeItem('valchrom-token-expiry');
          window.localStorage.removeItem('valchrom-user');
          this.$store.dispatch('logout');
          this.$router.push({path: '/'});
        })
        .catch(() => {
          this.$toast.open({
            type: 'is-danger',
            icon: 'error_outline',
            message: `Something went wrong! Please contact the administrator!`,
            duration: 5000,
            position: "is-top"
          });
        });
    }
  },
  mounted(){
    this.checkSession()
  }
}
</script>

<style lang="scss">
  // Import Bulma's core
  @import "~bulma/sass/utilities/_all";
  
  // Set colors
  $primary: #00a265; // #8c67ef color code can be changed here for primary
  $primary-invert: findColorInvert($primary);
  $info: #3a416f;
  $info-invert: findColorInvert($info);
  $valchrom: #8c67ef; // or custom color variable can be defined
  $valchrom-invert: findColorInvert($valchrom);

  // Setup $colors to use as bulma classes (e.g. 'is-valchrom')
  $colors: (
      "white": ($white, $black),
      "black": ($black, $white),
      "light": ($light, $light-invert),
      "dark": ($dark, $dark-invert),
      "primary": ($primary, $primary-invert),
      "info": ($info, $info-invert),
      "success": ($success, $success-invert),
      "warning": ($warning, $warning-invert),
      "danger": ($danger, $danger-invert),
      "valchrom": ($valchrom, $valchrom-invert) // this allows us to use the class 'is-valchrom'
  );

  // Links
  $link: $info;
  $link-invert: $info-invert;
  $link-focus-border: $info;

  // Import Bulma and Buefy styles
  @import "~bulma";
  @import "~buefy/src/scss/buefy";

  #app {
    font-family: "Segoe UI", "Roboto", "Oxygen", "Ubuntu", "Fira Sans", "Droid Sans", "Avenir", "Helvetica", "Arial", "sans-serif";
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  #nav {
    padding: 30px;
  }

  #nav a {
    font-weight: bold;
    color: #2c3e50;
  }

  #nav a.router-link-exact-active {
    color: #42b983;
  }

  .Site {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  .Site-content {
    flex: 1;
  } 

  .p-input-label {
      font-weight: 600;
      margin-bottom: 0.5em;
  }

  .font-weight-600{
    font-weight: 600;
  }
  
  .fullWidth{
      min-width: 100%;
  }

    .modal {
        z-index: 1000;
    }
</style>

